import Vue          from 'vue';
import Router       from 'vue-router';
import OAuthView    from './components/Views/OAuthView';
import OverView     from './components/Views/OverView';
import PageView     from './components/Views/PageView';
import ResourceView from './components/Views/ResourceView';
import TypesView    from './components/Views/TypesView';

/* eslint-disable */
Vue.use(Router);

export const ROUTE_DOCS     = 'docs';
export const ROUTE_OAUTH    = 'oauth';
export const ROUTE_TYPES    = 'types';
export const ROUTE_PAGE     = 'page';
export const ROUTE_RESOURCE = 'resource';

export default new Router({
  mode:   'history',
  base:   '/docs/',
  routes: [
    {
      path:      '/',
      name:      ROUTE_DOCS,
      component: OverView,
      props:     true,
    },
    {
      path:      '/oauth',
      name:      ROUTE_OAUTH,
      component: OAuthView,
      meta:      {
        hideMenu: true,
      },
    },
    {
      path:      '/types',
      name:      ROUTE_TYPES,
      component: TypesView,
    },
    {
      path:      '/resource/:slug',
      name:      ROUTE_RESOURCE,
      props:     true,
      component: ResourceView,
    },
    {
      path:      '/:slug',
      name:      ROUTE_PAGE,
      props:     true,
      component: PageView,
    },
  ],

  scrollBehavior ( to, from, savedPosition ) {
    if ( to.hash ) {
      return {
        selector: to.hash,
        offset:   {
          y: 32,
        },
      };
    }

    return savedPosition
      ? savedPosition
      : { x: 0, y: 0 };
  },
});
